var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderCount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 2.66699H4.66659C3.93021 2.66699 3.33325 3.26395 3.33325 4.00033V12.667C3.33325 13.4034 3.93021 14.0003 4.66659 14.0003H11.3333C12.0696 14.0003 12.6666 13.4034 12.6666 12.667V4.00033C12.6666 3.26395 12.0696 2.66699 11.3333 2.66699Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10M6 8.66667H10M6 11.3333H8.66667",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCount);
export default __webpack_public_path__ + "static/media/order_count.14ab0dae42c5a2abb95cc7f79830c7e1.svg";
export { ForwardRef as ReactComponent };